import { camelCase } from './camelCase'

const IncreaseIdRE = /^([$A-Z_a-z][\w$-]*?)(\d+)?$/

const Cache = new Map<string, any[]>()

export function parseID(id: string | undefined, fallbackIncreaseKey: string) {
  const cacheKey = id ? `${id}-${fallbackIncreaseKey}` : fallbackIncreaseKey
  if (Cache.has(cacheKey)) return Cache.get(cacheKey)
  if (id) {
    const parsed = String(id).match(IncreaseIdRE)
    if (parsed) {
      let value: [string, number]
      const prefix = parsed[1]
      const number = parsed[2]
      if (number) {
        const num = Number(number)
        value =
          number.length >= 20 || num > Number.MAX_SAFE_INTEGER
            ? [prefix + number, -1]
            : [prefix, num]
      } else {
        value = [prefix, -1]
      }
      Cache.set(cacheKey, value)
      return value
    }
  }
  const value = [camelCase(fallbackIncreaseKey), -1]
  Cache.set(cacheKey, [camelCase(fallbackIncreaseKey), -1])
  return value
}
